













































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

import Customer from "@/types/customer/Customer";

import { getFileNameFromLink } from "@/utils/fileName";
import Endpoint from "@/utils/endpoint";
import formatDate, { formatDateWithTime } from "@/utils/formatDate";
import Header from "@/types/app/header";
import InvestorHeader from "../headers/investors-header";
import InvestorAccountHeader from "../headers/investor-account-header";
import AccountInterface, { accountInitialValue } from "@/types/app/accounts";
import CustomerService from "@/services/customerService";
import AccountService from "@/services/accountService";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import BaseComponent from "@/utils/baseComponent";
import compareTo from "@/utils/compareTo";
import InvestorInterface, { investorInitialValue } from "@/types/app/investor";


@Component({
  props: ["visible", "investor"],
})
export default class ModalInvestorDetailAccount extends BaseComponent {
  loading = false;
  investorData: InvestorInterface = investorInitialValue;
  editedAccount: AccountInterface = accountInitialValue;
  accountService = new AccountService(this.$http);
  customerService = new CustomerService(this.$http);
  dialogAccountDelete = false;
  existsClient = 'No';
  dialogAccount = false;
  editedAccountIndex = -1;
  funds: VuetifySelectItems[] = [];
  valid = false;
  investorAccountHeaders: Header[] = InvestorAccountHeader.header;
  accounts: AccountInterface[] = [];
  customersOthers: VuetifySelectItems[] = [];
  selectedCustomers: VuetifySelectItems[] = [];
  loadingAccounts = false;
  statusFormFillColor = {
    "Not Started": "not-started",
    "Filling in": "filling-in",
    Filled: "filled",
  };
  getFileNameFromLink = getFileNameFromLink;
  formatDate = formatDate;
  formatDateWithTime = formatDateWithTime;

  private endpoint = new Endpoint();


  get formAccountTitle() {
        return this.editedAccountIndex === -1 ? 'New Account' : 'Edit Accountc'
    }

    mounted(){
      if(this.investorData.id){
        this.loadAccounts(this.investorData.id);
      }
    }
  
  @Watch("investor")
  async load(investor:InvestorInterface) {
    this.investorData = investor;
    this.loadingAccounts = true;
    const [fundResponse, _] = await Promise.all([
      this.getProductFunds(),
      this.loadAccounts(investor.id),
    ]);
    this.funds = fundResponse;   
    this.loadingAccounts = false;
  }

  relationShip(investor: Customer): string {
    if (investor && investor.relationships) {
      for (let i = 0; i < investor.relationships.length; i++) {
        if (investor.relationships[i].typeRelationship === 1) {
          return investor.relationships[i].name;
        }
      }
    }

    return "";
  }

  closeAccountModal() {
    this.dialogAccount = false;
    this.$nextTick(() => {
      this.editedAccount = Object.assign({}, accountInitialValue)
      this.editedAccountIndex = -1;
      this.selectedCustomers = [];
      this.existsClient = 'No';
      this.investorData =  Object.assign({}, investorInitialValue);
      this.$emit("closeShowAcounts");
    })

  }

  
  async getProductFunds(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productFund;
    const response = await this.$http.get(`${url}?hasInvestment=false`);
    const productFunds = response.data;
    const productFundsOrdened = productFunds.sort((a:any, b:any) =>
      compareTo(a.fundSiteName, b.fundSiteName)
    );

    const itemsForVuetifySelect = productFundsOrdened.map((productFund:any) => ({
      text: productFund.fundSiteName,
      value: productFund.fundId,
      data: productFund,
    }));

    return itemsForVuetifySelect;
  }

  async loadAccounts(investorId:string){
   this.accounts = await this.accountService.getAccountsByInvestorId(investorId)
  }

  async addAccountModal() {
    if (!this.form().validate()) {
      return false;
    }

    if(this.accounts?.some(x => x.fundId ==  this.editedAccount.fund.value 
                                 && x.accountNumber == this.editedAccount.accountNumber)){
                                  this.showError(`Investor with account number ${this.editedAccount.accountNumber} and
                                   fund ${ this.editedAccount.fund.text} already!`);
                                   return;
                                 }
    this.loadingAccounts = true;
    try {

      this.editedAccount.userId = this.investorData.id;
      this.editedAccount.fundId = this.editedAccount.fund.value;
      this.editedAccount.fundName = this.editedAccount.fund.text;
      
      await this.accountService.saveAccount(this.editedAccount, this.editedAccountIndex > 0);
      this.showSuccess('Save an account with successfully');
      await this.loadAccounts(this.editedAccount.userId);
      this.closeAccountModal();

    } finally {
      this.loadingAccounts = false;
    }

  }
  closeAccountDelete() {
    this.dialogAccountDelete = false
    this.$nextTick(() => {
      this.editedAccount = Object.assign({}, accountInitialValue);
      this.editedAccountIndex = -1
    })
  }
  async deleteAccountConfirm() {
    this.loadingAccounts = true;
    try {
      await this.accountService.deleteAccount(this.editedAccount.id);
      await this.loadAccounts(this.investorData.id);
      this.showSuccess('Delete an account with successfully');
      this.closeAccountDelete()
    }
    finally {
      this.loadingAccounts = false;
    }
  }

  editAccountClick(item: AccountInterface) {

    this.editedAccountIndex = this.accounts.indexOf(item);
    console.log('editInvestorItem', item, this.editedAccountIndex);
    this.editedAccount = Object.assign({}, item)
    this.dialogAccount = true
  }

  deleteAccountClick(item: AccountInterface) {
    this.editedAccountIndex = this.accounts.indexOf(item)
    this.editedAccount = Object.assign({}, item)
    this.dialogAccountDelete = true
  }

}
